import React, {useCallback} from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

// Static sx objects hoisted to module scope
const TABS_SX = {
    borderBottom: 1,
    borderColor: 'divider',
    minHeight: 36,
    '& .MuiTab-root': {
        minHeight: 36,
        py: 1,
        textTransform: 'none',
        fontSize: '0.875rem',
    },
};
const COUNT_BOX_SX = {display: 'flex', alignItems: 'center', gap: 0.5};

/**
 * Tab navigation component for the ReferenceMarker
 * Displays Added, Suggested, and Claims tabs
 */
const ReferenceMarkerTabs = React.memo(function ReferenceMarkerTabs({
    activeTab,
    onTabChange,
    sortedReferencesCount,
    suggestedCitationsCount,
    suggestionsLoading,
    analysisLoading,
    claimsInsightsLoading,
    claimsSummary,
}) {
    const totalClaims = claimsSummary?.total_claims ?? 0;
    const claimsTabLoading = analysisLoading || claimsInsightsLoading;

    const handleChange = useCallback((e, newValue) => {
        onTabChange(newValue);
    }, [onTabChange]);

    return (
        <Tabs
            value={activeTab}
            onChange={handleChange}
            sx={TABS_SX}
        >
            {/* Tab 0: Added References */}
            <Tab label={`Added (${sortedReferencesCount})`}/>

            {/* Tab 1: Suggested Citations (from y-websocket backend) */}
            <Tab
                label={
                    <Box sx={COUNT_BOX_SX}>
                        Suggested
                        {suggestionsLoading ? (
                            <CircularProgress size={12} thickness={4}/>
                        ) : (
                            ` (${suggestedCitationsCount ?? 0})`
                        )}
                    </Box>
                }
            />

            {/* Tab 2: Claims Analysis */}
            <Tab
                label={
                    <Box sx={COUNT_BOX_SX}>
                        Claims
                        {claimsTabLoading ? (
                            <CircularProgress size={12} thickness={4}/>
                        ) : (
                            ` (${totalClaims})`
                        )}
                    </Box>
                }
            />
        </Tabs>
    );
});

export default ReferenceMarkerTabs;
